import React from 'react';
import PropTypes from 'prop-types';
import {Box, Typography} from 'views/components';
import {Translate} from 'views/module';

const CareRoutineBoxView = (props) => {
  const {data} = props;

  return (
    <Box style={{background: 'white', borderRadius: '1rem', boxShadow: '0 1px 6px rgba(0,0,0,0.1)', padding: '1rem', position: 'relative'}}>
      {/* Main Title */}
      <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem'}}>
        <Typography variant="h6">
          <Translate expression="profile.CareRoutineBox.Title"/>
        </Typography>
      </Box>

      {/* Client Routine */}
      <Typography variant="subtitle2" style={{marginTop: 0}}>
        <Translate expression="profile.CareRoutineBox.ClientRoutine" />
      </Typography>
      {
        data.clientRoutine && (
          <Box sx={{padding: '0.5rem 0'}}>
            <Typography style={{whiteSpace: 'pre-line', color: '#374151', fontSize: 14}}>{data.clientRoutine}</Typography>
          </Box>
        )
      }
      {
        !data.clientRoutine && (
          <Typography style={{color: '#71717A', fontStyle: 'italic', fontSize: '0.875rem', padding: '0.5rem 0'}}>
            <Translate expression="profile.CareRoutineBox.ClientRoutinePlaceholder" />
          </Typography>
        )
      }

      {/* Daily Tasks */}
      <Typography variant="subtitle2" style={{marginTop: '0.5rem'}}>
        <Translate expression="profile.CareRoutineBox.DailyTasks" />
      </Typography>
      {
        data.dailyTasks && (
          <ul
            style={{paddingLeft: '2rem', marginTop: '0.5rem', marginBottom: 0, color: '#374151', fontSize: 14}}
          >
            {data.dailyTasks.map((task, i) => (
              <li key={i}>{task}</li>
            ))}
          </ul>
        )
      }
      {
        !data.dailyTasks && (
          <Typography style={{color: '#71717A', fontStyle: 'italic', fontSize: '0.875rem', marginTop: '0.5rem', marginBottom: 0}}>
            <Translate expression="profile.CareRoutineBox.DailyTasksPlaceholder" />
          </Typography>
        )
      }
    </Box>
  );
};

CareRoutineBoxView.propTypes = {
  data: PropTypes.shape({
    clientRoutine: PropTypes.string,
    dailyTasks: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
};

export default CareRoutineBoxView;
